import * as monaco from "monaco-editor";
import editorWorker from "monaco-editor/esm/vs/editor/editor.worker?worker";
import cssWorker from "monaco-editor/esm/vs/language/css/css.worker?worker";
import htmlWorker from "monaco-editor/esm/vs/language/html/html.worker?worker";
import jsonWorker from "monaco-editor/esm/vs/language/json/json.worker?worker";
import tsWorker from "monaco-editor/esm/vs/language/typescript/ts.worker?worker";

self.MonacoEnvironment = {
  getWorker(_moduleId: string, label: string) {
    if (label === "json") return new jsonWorker();
    if (label === "css" || label === "scss" || label === "less") return new cssWorker();
    if (label === "html" || label === "handlebars" || label === "razor") return new htmlWorker();
    if (label === "typescript" || label === "javascript") return new tsWorker();
    return new editorWorker();
  },
};

monaco.editor.defineTheme("codex-dark", {
  base: "vs-dark",
  inherit: true,
  rules: [],
  colors: {
    "editor.background": "#0d0d0f",
    "editor.foreground": "#d8d8dc",
    "editorLineNumber.foreground": "#55555c",
    "editorLineNumber.activeForeground": "#96969f",
    "editor.selectionBackground": "#2a3b52",
    "editor.inactiveSelectionBackground": "#202b3a",
    "editorCursor.foreground": "#e8e8eb",
    "editorIndentGuide.background1": "#202024",
    "editorIndentGuide.activeBackground1": "#3a3a40",
  },
});

export { monaco };
